// As peças da barra das telas que a conversa abre em diálogo (resultados de
// hotel, carro e voo), montadas sobre a `ScreenBar` do ui-kit: o ✕ que fecha
// e a trilha do host ao lado dele, só no desktop.
import type { ReactNode, Ref } from 'react';
import { XIcon } from '@phosphor-icons/react';
import { Button } from '@voll-intelligence/ui-kit/ui/button';
import { useGenUiConfig, type GenUiTakeoverVertical } from './config.js';

/** O ✕ que fecha a tela: o botão ghost do kit, em tom secundário. */
export function ScreenBarClose({
  label,
  onClick,
  ref,
}: Readonly<{ label: string; onClick: () => void; ref?: Ref<HTMLButtonElement> }>): ReactNode {
  return (
    <Button
      ref={ref}
      type="button"
      variant="ghost"
      size="icon"
      className="text-muted-foreground"
      aria-label={label}
      onClick={onClick}
    >
      <XIcon className="size-4.5" aria-hidden />
    </Button>
  );
}

/** A trilha do host (`GenUiConfig.takeoverTrail`), com a conversa no lugar do
 *  `Início`; só no desktop. Ausente no config ⇒ nada. */
export function useScreenBarTrail(vertical: GenUiTakeoverVertical, onClose: () => void): ReactNode {
  const { takeoverTrail } = useGenUiConfig();
  const trail = takeoverTrail?.({ vertical, onClose });
  return trail ? <div className="flex min-w-0 max-wide:hidden">{trail}</div> : null;
}
